import { generatePath } from 'react-router-dom'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { NameDto } from 'api/Common/Types'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'
import { isEmpty } from 'utils/is-empty'

import '../Clients.scss'

import { TradingAccountKey } from 'api/Clients/Types/TradingAccount'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const clientDetailsTradingAccountWalletDetailsColumn: GridColumn[] = [
  {
    title: 'Account number',
    field: 'name',
    show: true,
    filter: 'text',
    width: 130,
    minResizableWidth: 120,
    cell: (props: GridCellProps) => (
      <td
        className='table-columns__content'
        style={{ color: 'var(--link)', textDecoration: 'underline' }}
      >
        <Link
          to={{
            pathname: generatePath(links.recordsTradingAccounts.detailsUrl as string, {
              id: props.dataItem.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.name}
        </Link>
      </td>
    ),
  },
  {
    title: 'IB',
    width: 100,
    field: 'introducingBroker.name',
    cell: (props: GridCellProps): JSX.Element => {
      if (isEmpty(props.dataItem.introducingBroker)) {
        return <td />
      }
      return (
        <td
          className='table-columns__content'
          style={{ color: 'var(--link)', textDecoration: 'underline' }}
        >
          <Link
            to={{
              pathname: generatePath(links.recordsIntroducingBrokers.detailsUrl as string, {
                id: props.dataItem.introducingBroker.id,
                slug: 'details',
              }),
            }}
          >
            {props.dataItem.introducingBroker.name}
          </Link>
        </td>
      )
    },
    show: true,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'Platform',
    width: 90,
    field: 'platformType.name',
    show: true,
    className: 'table-columns__content',
  },
  {
    title: 'Account Type',
    width: 120,
    field: 'accountType.name',
    show: true,
    className: 'table-columns__content',
  },
  {
    title: 'Currency',
    width: 90,
    field: 'currency.id',
    show: true,
    className: 'table-columns__number',
  },
  {
    title: 'Account Group',
    width: 120,
    field: 'accountGroup.name',
    cell: (props: GridCellProps): JSX.Element => {
      if (isEmpty(props.dataItem.accountGroup)) {
        return <td />
      }
      return (
        <td
          className='table-columns__content'
          style={{ color: 'var(--link)', textDecoration: 'underline' }}
        >
          <Link
            to={{
              pathname: generatePath(links.recordsAccountGroups.detailsUrl as string, {
                id: props.dataItem.accountGroup.id,
                slug: 'details',
              }),
            }}
          >
            {props.dataItem.accountGroup.name}
          </Link>
        </td>
      )
    },
    show: true,
    className: 'table-columns__content',
  },
  {
    title: 'Leverage',
    width: 90,
    field: 'leverageType.name',
    show: true,
    className: 'table-columns__number',
  },
  {
    title: 'Campaign',
    width: 90,
    field: 'campaigns',
    cell: (props: GridCellProps): JSX.Element => {
      const campaigns: NameDto<string>[] = props.dataItem.campaigns || []
      return <td className='table-columns__content'>{campaigns.map((x) => x.name).join(', ')}</td>
    },
    show: true,
    className: 'table-columns__number',
  },
  {
    title: 'Automatic Closure',
    width: 90,
    field: TradingAccountKey.automaticClosure,
    cell: (props: GridCellProps): JSX.Element => {
      const campaigns = props.dataItem.campaigns || []
      const hasAutomaticClosure = campaigns[0]?.automaticClosure
      if (hasAutomaticClosure === null) {
        return (
          <td style={{ textAlign: 'center' }} className='table-columns__content'>
            N/A
          </td>
        )
      }

      return (
        <td style={{ textAlign: 'center' }} className='table-columns__content'>
          <input type='checkbox' checked={hasAutomaticClosure} disabled />
        </td>
      )
    },
    show: true,
    filterable: true,
    className: 'table-columns__content',
  },
  {
    title: 'Status',
    width: 90,
    field: 'status.name',
    show: true,
    className: 'table-columns__number',
  },
  {
    title: 'Created',
    width: 100,
    field: 'createdDate',
    show: true,
    filter: 'text',
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(props.dataItem.createdDate, true)}
      </td>
    ),
  },
  {
    title: 'Modified',
    width: 100,
    field: 'updatedDate',
    show: true,
    filter: 'text',
    cell: (props: GridCellProps) => (
      <td className='table-columns__date'>
        {formatLocalDateUTC(props.dataItem.updatedDate, true)}
      </td>
    ),
  },
]

export default clientDetailsTradingAccountWalletDetailsColumn
